import { lazy } from 'react'

export const SatisfactionLazy = lazy(() => import('./Satisfaction'))
